import { Routes, Route, Navigate } from 'react-router-dom';
import { APP_ROUTES } from './routes';
import AccessGuard from './AccessGuard';

import Layout from 'containers/layout/Layout';
import NoAuthLayout from 'containers/NoAuthLayout';

const Index = () => {
	const userRole = localStorage.getItem("role");

	// Функция для автоматического редиректа в зависимости от роли
	const getDefaultRoute = (role) => {
		const redirects = {
			// 'MANAGEMENT': "/managment/users",
			// 'TECHNOLOGIST': "/technologist/dashboard",
		};
		return redirects[role] || "/auth/login";
	};

	return (
		<Routes>
			<Route element={<NoAuthLayout />}>
				{APP_ROUTES.filter(r => r.isPublic).map(route => (
					<Route key={route.path} path={route.path} element={route.component} />
				))}
			</Route>

			<Route element={<AccessGuard />}>
				<Route element={<Layout />}>
					{APP_ROUTES.filter(r => !r.isPublic).map(route => (
						<Route
							key={route.path}
							element={<AccessGuard roles={route.roles} />}
						>
							<Route path={route.path} element={route.component} />
						</Route>
					))}
				</Route>
			</Route>

			{/* 3. Глобальный редирект */}
			<Route path="*" element={<Navigate to={getDefaultRoute(userRole)} replace />} />
		</Routes>
	);
};

export default Index;